import { configure, makeObservable, observable, action, computed } from "mobx";
import { createContext, useContext } from "react";
import { getUserInfo, UserInfo } from "../utils/api";

configure({ enforceActions: "always" });

class Store {
  @observable loading = true;
  @observable userInfo: UserInfo | null = null;

  constructor() {
    makeObservable(this);
  }

  @computed get isAdmin() {
    if (!this.userInfo || !Array.isArray(this.userInfo.roles)) return false;
    return this.userInfo.roles.includes("admin");
  }

  @action
  login() {
    this.loading = true;
    getUserInfo()
      .then(
        action((userInfo) => {
          this.userInfo = userInfo;
          this.loading = false;
        })
      )
      .catch(action((e) => (this.loading = false)));
  }
}

export const store = new Store();

export const storeContext = createContext(store);

export const StoreProvider = storeContext.Provider;

export function useStore() {
  return useContext(storeContext);
}

store.login();

export default store;
